module.exports = __webpack_public_path__ + "img/onepack-active.ded741c1.svg";